<template>
  <div class="calendar-date-skeleton-wrapper">
    <div :class="clsx('calendar-date-skeleton', { 'calendar-date-skeleton__alignment': gridFixedHeight })" v-if="isLoading">
      <div class="skeleton-header">
        <div class="skeleton-block tiny"></div>
        <div class="flex">
          <div class="skeleton-block short mr-2"></div>
          <div class="skeleton-block short"></div>
        </div>
        <div class="skeleton-block tiny"></div>
      </div>
      <div class="calendar-grid">
        <div v-for="i in 42" :key="i" class="calendar-cell">
          <div class="skeleton-block tiny"></div>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import clsx from 'clsx';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    gridFixedHeight: {
      type: Boolean,
      default: false,
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.calendar-date-skeleton {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__alignment {
    padding: 56px 0;
  }
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
}

.calendar-cell {
  display: flex;
  justify-content: center;
}

.skeleton-block {
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 6px;
  animation: shimmer 1.4s infinite;

  &.short {
    width: 120px;
    height: 24px;
  }

  &.tiny {
    width: 32px;
    height: 32px;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
